import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AdminSessionService } from '../../services/admin-session/admin-session.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-system',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './system.component.html',
  styleUrls: ['./system.component.scss']
})
export class SystemComponent {
  constructor(
    private adminSessionService: AdminSessionService,
    private readonly toastr: ToastrService
  ) { }

  get adminSessionGuid(): string {
    return this.adminSessionService.getAdminIdentifier();
  }

  regenerateSessionGuid(): void {
    this.adminSessionService.regenerateAdminIdentifier();
    const newGuid = this.adminSessionGuid;
    if (newGuid) {
      this.toastr.success('Admin Session Identifier regenerated', 'Success');
    } else {
      this.toastr.warning('Unable to regenerate Admin Session Identifier', 'Warning');
    }
  }

  copyGuidToClipboard(): void {
    const identifier = this.adminSessionGuid;
    if (!identifier) {
      this.toastr.warning('No Identifier available to copy.', 'Nothing to copy');
      return;
    }

    navigator.clipboard.writeText(identifier)
      .then(() => {
        this.toastr.success('Admin Session Identifier copied to clipboard', 'Copied');
      })
      .catch(err => {
        console.error('Failed to copy Identifier:', err);
        this.toastr.error('Failed to copy Identifier to clipboard', 'Error');
      });
  }
}
